import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  HasSelectedBasketItemsGuard,
  QuoteCmsPageResolver,
} from '@common/data-access-quotes';
import { ErrorComponent } from './components/error/error.component';
import { StepCompletionNavigationGuard } from '@shared/data-access-navigation';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/products',
    pathMatch: 'full',
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: '.html',
    redirectTo: '/products',
    pathMatch: 'full',
  },
  {
    path: 'products',
    loadChildren: () =>
      import('@common/feature-appliance-details').then(
        (module) => module.CommonFeatureApplianceDetailsModule
      ),
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: 'quote.html',
    redirectTo: '/quote',
    pathMatch: 'full',
  },
  {
    path: 'quote',
    loadChildren: () =>
      import('@common/feature-quote').then(
        (module) => module.CommonFeatureQuoteModule
      ),
  },
  {
    path: 'checkout',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@common/feature-checkout-landing').then(
            (module) => module.CommonFeatureCheckoutLandingModule
          ),
      },
      {
        path: 'personal-details',
        loadChildren: () =>
          import('@common/feature-checkout-personal-details').then(
            (module) => module.CommonFeatureCheckoutPersonalDetailsModule
          ),
        resolve: {
          quoteData: QuoteCmsPageResolver,
        },
      },
      {
        path: 'logged-in',
        loadChildren: () =>
          import('@common/feature-checkout-logged-in-user').then(
            (module) => module.CommonFeatureCheckoutLoggedInUserModule
          ),
        resolve: {
          quoteData: QuoteCmsPageResolver,
        },
      },
      {
        path: 'direct-debit-payment',
        loadChildren: () =>
          import('@common/feature-checkout-direct-debit').then(
            (module) => module.CommonFeatureCheckoutDirectDebitModule
          ),
      },
      {
        path: 'order-confirmation',
        loadChildren: () =>
          import('@common/feature-order-confirmation').then(
            (module) => module.CommonFeatureOrderConfirmationModule
          ),
        resolve: {
          cmsData: QuoteCmsPageResolver,
        },
      },
    ],
    canActivate: [StepCompletionNavigationGuard, HasSelectedBasketItemsGuard],
  },
  { path: 'error', data: { title: 'Error' }, component: ErrorComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      paramsInheritanceStrategy: 'always',
      relativeLinkResolution: 'corrected',
    }),
  ],
  exports: [RouterModule],
})
export class HooverFeatureShellRoutingModule {} // Main routes for application
